import React, { Component } from 'react';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import ScrollSpacer from './ScrollSpacer';
import { connect } from 'react-redux';
import shared from '../../../utils/shared';
import { dp } from '../../../utils/shared.js';
import StoryMiami from './StoryMiami';
import RowButtonMiami from './RowButtonMiami';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class StoriesSimpleMiami extends Component {

  constructor(props) {
    super(props);
    this.navRefs = [];
    this._currentStory = {};
    this._subscribeModule = null;
    this.getSubscribeModule();
    this._rowWrapperRef = null;
    this._colorPallette = null;

    this._includePictures = false;
    this._modalIsOnScreen = false;
    const type = _.get(this.props.module, 'contents.custom_fields.folder_type.val.value', null);
    if (type === "donor_stories_text_block_picture") {
      this._includePictures = true;
    }

    this._showStoryCycle = null;
    this._modalEnabled = this.props.module.modalEnabled === undefined ? false : this.props.module.modalEnabled;

    this.state = {
      initializedRefs: false,
      contentIndex: 0
    };
    this._stories = _.orderBy(this.props.module.children, story => {
      return story.sorting_name.toLowerCase();
    });
  }

  initializeNavRefs = () => {
    if (this.state.initializedRefs === false) {
      for (let a = 0; a < this.navRefs.length; a++) {
        if (this._modalEnabled) {
          this.navRefs[a].el.addEventListener("tap", () => this.handleNav(a));
        }
      }
      this.setState({
        initializedRefs: true
      })
    }
  }

  componentDidMount() {
    this.checkSwipeAnimation();
    if (this._rowWrapperRef) {
      this._rowWrapperRef.addEventListener("tap", () => this.redirect());
    }
  }

  checkSwipeAnimation = () => {
    const wrapperHeight = this._wrapperDiv.getBoundingClientRect().height;
    const contentHeight = this._innerDivRef.getBoundingClientRect().height;
  
    this.props.handleSwipeAnimation(wrapperHeight, contentHeight);
  }

  handleScrollStart = () => {
    this.props.cancelSwipeAnimation();
  }

  handleNav = (a) => {
    this.setState({
      contentIndex: a,
      showStory: false
    });

    if (this._modalIsOnScreen) {
      setTimeout(() => {
        this._modalIsOnScreen = true;
        this.setState({
          showStory: true
        });
      }, 500);
    } else {
      this._modalIsOnScreen = true;
      this.setState({
        showStory: true
      });
    }

    clearTimeout(this._showStoryCycle);
    this._showStoryCycle = null;
    this._showStoryCycle = setTimeout(() => {
      this._modalIsOnScreen = false;
      this.setState({
        showStory: false
      })
    }, 60000);
  }

  getBackgroundImage = () => {
    const defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' }
    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[2]', null), null);
  }

  getIconImage = () => {
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[1]', null), null);
  }

  getSubscribeModule = () => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const menu = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
    });
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    const subscribeModule = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(menu.id) && type === "be_the_change";
    });
    this._subscribeModule = subscribeModule;
  }

  renderStory = (row, i) => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    let uiStrip = "/img/miami/general/rainbowuistrip_dark.png";
    if (this._colorPallette === "adaptive") {
      uiStrip = "/img/miami/general/rainbowuistrip_dark_green.png";
    }
    const unit = this.props.screen.r9_16.p10

    let imageWidth = 0
    let textWidth = 41
    let totalWidth = 47.5

    let boxStyle = {
      paddingLeft: '3.375vh',
      paddingRight: '3.375vh',
      paddingTop: '1.96875vh',
      paddingBottom: '1.96875vh',
      width: textWidth + 'vh'
    }

    if (this._includePictures) {
      imageWidth = 14
      textWidth = totalWidth - imageWidth - 5
      boxStyle = {
        paddingLeft: '2.5vh',
        paddingRight: '2.5vh',
        paddingTop: '1.5vh',
        paddingBottom: '1.5vh',
        width: textWidth + 'vh'
      }
    }

    let richTextWrapper = {
      width: textWidth + 'vh',
      overflowY: 'hidden',
      verticalAlign: 'top'
    }

    if (this._includePictures) {
      richTextWrapper.height = '8vh'
    }

    // let backgroundImage = shared.dp(this.props.screen, row.contents.images[0]);
    const backgroundImage = shared.presetDp("story_text_block_picture", _.get(row, 'contents.images[0]', {path: '/img/ui/', file_name: 'image_default.png'}), this.props.screen);
    const bodyRichText = new QuillDeltaToHtmlConverter(_.get(row, 'contents.custom_fields.body.val.ops', _.get(row, 'contents.custom_fields.body.default.ops', null)), {}).convert();
    return (
      <div key={i} ref={el => this.navRefs[i] = { el: el, module: row }} style={{ width: totalWidth + 'vh', height: '15vh', display: "table", lineHeight: '140%', marginTop: '1.5vh', backgroundColor: 'white', fontSize: '1.96875vh', fontFamily: "opensans-bold", color: '#404040', borderTopLeftRadius: unit * 0.08, borderTopRightRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08, borderBottomRightRadius: unit * 0.08 }}>
        {
          this._includePictures ?
            <div style={{ width: imageWidth + 'vh', display: "table-cell", backgroundImage: "url(" + backgroundImage + ")", backgroundSize: "cover", backgroundPosition: "center", borderTopLeftRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08 }} />
            : null
        }
        <div style={{ ...boxStyle, display: "table-cell" }}>
          <div className="fullEllipsis" style={{ width: textWidth + 'vh', position: 'relative', fontSize: "2.1875vh", textOverflow: 'ellipsis' }}>
            {row.name}
          </div>
          <hr style={{ backgroundImage: "url(" + uiStrip + ")", backgroundSize: "cover", backgroundPosition: "center", height: "0.098958333vh" }} />
          <div className='no-margin' style={richTextWrapper}>
            <div style={{ lineHeight: '65%', touchAction: "none" }} dangerouslySetInnerHTML={{ __html: bodyRichText }} />
          </div>
        </div>
        {/* <br /> */}
      </div>
    )
  }

  renderStories = () => {
    let learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
    if (this._colorPallette === "adaptive") {
      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png";
    }
    return (
      this._stories.map(function (row, i) {
        return (
          <div key={i}>
            <div className="miami-bullet">
              {this.renderStoryWithSpacer(row, i)}
            </div>
            <div>
              {
                this._stories.length <= 1 && this._includePictures ?
                  <div ref={el => this._rowWrapperRef = el}>
                    <RowButtonMiami
                      header="Be the change"
                      message="Help make a difference by becoming a donor."
                      button={learnMoreButton}
                    />
                  </div>
                  : null
              }
            </div>
            <div>
              {
                this._stories.length <= 2 && !this._includePictures && i >= 1 ?
                  <div ref={el => this._rowWrapperRef = el}>
                    <RowButtonMiami
                      header="Get Involved"
                      message="Learn about the many ways you can help"
                      button={learnMoreButton}
                    />
                  </div>
                  : null
              }
            </div>
          </div>
        )
      }, this)
    )
  }

  renderStoryWithSpacer = (row, i) => {
    let learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
    if (this._colorPallette === "adaptive") {
      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png";
    }
    let story = this.renderStory(row, i);
    let insertRowAt = this._includePictures ? 1 : 2;
    let RowButtonProperty = {};

    if (this._includePictures) {
      // let insertSpacerAt = 1;
      RowButtonProperty = {
        header: "Be the change",
        message: "Help make a difference by becoming a donor.",
        button: learnMoreButton
      }
    } else {
      // let insertSpacerAt = 2;
      RowButtonProperty = {
        header: "Get Involved",
        message: "Learn about the many ways you can help",
        button: learnMoreButton
      }
    }

    return (
      <div key={i}>
        {i === insertRowAt ?
          <div ref={el => this._rowWrapperRef = el}>
            <RowButtonMiami
              header={RowButtonProperty.header}
              message={RowButtonProperty.message}
              button={RowButtonProperty.button}
            />
          </div>
          : null}
        {story}
      </div>

    )
  }

  redirect = () => {
    if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
      this.props.navRoute('/miami/subscribe', this._subscribeModule);
    }
  }

  render() {
    const unit = this.props.screen.r9_16.p10
    const backgroundImage = this.getBackgroundImage();
    const iconImage = this.getIconImage();
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;

    return (
      <div>
        <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize }} >
          <div style={{ position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber }} >
            <div style={{ display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
              <div style={{ height: "4vh" }}>
              </div>
              <img alt="icon" src={iconImage} style={{ width: '16vh' }} />
            </div>
            <div style={{ fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '3.6vh' }}>
              {this.props.module.name.toUpperCase()}
            </div>
            <div style={{ fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center", paddingRight: "9.375vh", paddingLeft: "9.375vh" }}>
              {this.props.module.description}
            </div>
            <div style={{ height: '3.088541667vh' }} />
            {this._includePictures ?
              <div style={{ height: "1.82291666666666666667vh" }}></div>
              : null
            }
            <div className="topgradblackP25" style={{ position: "absolute", width: '100%', height: unit * .25, top: "26.979166667vh", left: 0 }} />
            <div ref={el => this._wrapperDiv = el} style={{ color: 'black', width: '85%', height: "72.91vh", maxHeight: "72.91vh", display: "block", marginLeft: "auto", marginRight: "auto", touchAction: "none" }}>
              <ReactIScroll ref={el => this.iScroller = el}    iScroll={iScroll}
                onScrollStart={this.handleScrollStart}
                options={{
                  mouseWheel: true,
                  scrollbars: false,
                  scrollX: false,
                  scrollY: true,
                  probeType: 2,
                  bounce: false,
                  momentum: true,
                  deceleration: 0.005,
                  useTransition: true,
                  disableTouch: false,
                  disablePointer: false,
                  disableMouse: false,
                  tap: true
                }}
                onRefresh={this.initializeNavRefs}
              >
                <div ref={el => this._innerDivRef = el}>
                  <div style={{ height: "3vh" }} />
                  {this.renderStories()}
                  <ScrollSpacer unit={unit} />
                </div>
              </ReactIScroll>
            </div>
          </div>
          <div style={{ position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber, left: this.props.screen.screenWidth / this.props.screensNumber }}>
            <CSSTransitionGroup
              component='div'
              className="containerFade"
              style={{ minHeight: '100%' }}
              transitionName='example'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
              <div key={this.state.showStory}>
                {this.state.showStory ?
                  <StoryMiami
                    showBackground={false}
                    stories={this._stories}
                    screen={this.props.screen}
                    mode={this.props.mode}
                    contentIndex={this.state.contentIndex}
                    screensNumber={this.props.screensNumber}
                  />
                  : null}
              </div>
            </CSSTransitionGroup>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
  };
};

export default connect(mapStateToProps, null)(StoriesSimpleMiami);



// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/StoriesSimpleMiami.js